import { createAction, createSlice } from '@reduxjs/toolkit';
import { DirectPost, EditablePost } from './types';

export interface State {
  data: DirectPost[];
  fetchComplete: boolean;
  newPostModalStatus: boolean;
  modifyPostModalStatus: boolean;
  deletePostModalStatus: boolean;
  selectedPost: DirectPost;
  editor: EditablePost;
}

export const initialState: State = {
  data: [],
  fetchComplete: false,
  newPostModalStatus: false,
  modifyPostModalStatus: false,
  deletePostModalStatus: false,
  selectedPost: {} as DirectPost,
  editor: {} as EditablePost,
};

const DirectPosts = createSlice({
  name: 'directPosts',
  initialState,
  reducers: {
    fetchPostsSuccess(state, { payload }) {
      state.data = payload;
      state.fetchComplete = true;
    },
    fetchPostsFailed: state => {
      state.fetchComplete = false;
      state.data = [];
    },
    toggleNewPostModal: state => {
      state.newPostModalStatus = !state.newPostModalStatus;
      state.editor = {} as EditablePost;
    },
    toggleDeletePostModal(state, { payload }) {
      state.deletePostModalStatus = !state.deletePostModalStatus;
      state.selectedPost = payload;
    },
    toggleModifyPostModal(state, { payload }) {
      state.modifyPostModalStatus = !state.modifyPostModalStatus;
      state.selectedPost = payload;
      state.editor = payload;
    },
    updateTitle(state, { payload }) {
      state.editor = {
        ...state.editor,
        title: payload,
      };
    },
    updateText(state, { payload }) {
      state.editor = {
        ...state.editor,
        text: payload,
      };
    },
    updateUrl(state, { payload }) {
      state.editor = {
        ...state.editor,
        link: payload,
      };
    },
    updateImage(state, { payload }) {
      state.editor = {
        ...state.editor,
        headerImage: payload,
      };
    },
    modifyPostSuccess: state => {
      state.editor = {} as EditablePost;
    },
    createPostSuccess: state => {
      state.editor = {} as EditablePost;
    },
    clearImage: state => {
      state.editor = {
        ...state.editor,
        headerImage: null,
      };
    },
  },
});

// Export slice actions
export const {
  fetchPostsSuccess,
  fetchPostsFailed,
  toggleNewPostModal,
  toggleModifyPostModal,
  toggleDeletePostModal,
  updateTitle,
  updateText,
  updateImage,
  updateUrl,
  modifyPostSuccess,
  createPostSuccess,
  clearImage,
} = DirectPosts.actions;

// Export custom saga actions
export const deletePostSuccess = createAction('DELETE_POST_SUCCESS');
export const fetchPosts = createAction('FETCH_POSTS');
export const createPost = createAction('NEW_POST', (newPost: EditablePost) => ({
  payload: {
    newPost,
  },
}));
export const modifyPost = createAction(
  'MODIFY_POST',
  (updatedPost: DirectPost) => ({
    payload: {
      updatedPost,
    },
  }),
);
export const deletePost = createAction(
  'DELETE_POST',
  (deletedPost: DirectPost) => ({
    payload: {
      deletedPost,
    },
  }),
);

export default DirectPosts.reducer;
